import './index.less';
import DefaultIcon from './icon';

export default (props) => {
  const { erp = '', name = '', size = 'middle', group = '' } = props;
  return (
    <span className="TY_dongdong">
      <span className={`TY_dongdong_name size_${size}`}>{name}</span>
      {(erp || group) && (
        <DefaultIcon
          size={size}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            erp
              ? (window.location.href = `timline://chat/?topin=${erp}`)
              : (window.location.href = `timline://chat/?topin=${group}&type=2`);
          }}
        />
      )}
    </span>
  );
};
